import {Signals, UIManager} from "@/Imports";
import Stage from "../stage/Stage";
import Config from "../config/Config";
import Facade from "../Facade";
import MainContainer from "../containers/MainContainer";
import ApplicationLoader from "./ApplicationLoader";
import GameManager from "../managers/GameManager";
import Model from "../model/Model";
import PreloaderContainer from "../containers/PreloaderContainer";
import TextFactory from "@localisation/TextFactory";
import * as PIXI from "pixi.js";
import Platform from "@base/utils/Platform";
//import FullscreenIOSController from "@/stage/FullscreenIOSController";
import BackendManager from "@/managers/comunication/BackendManager";
import SplashScreenContainer from "@/containers/SplashScreenContainer";
import DataField from "@/model/DataField";

export default class Application {
  constructor () {
    this.count = 0
    this.isGameLoaded = false
    this.isUIIsLoaded = false
    this.isUIInited = false

    PIXI.utils.clearTextureCache()
    Signals.loadAssets.add(this.onLoadAssets, this)

    Signals.preloaderAssetsLoadingComplete.add(this.onPreloaderAssetsLoadingComplete, this)
    Signals.mainGameAssetsLoadingComplete.add(this.onMainGameAssetsLoadingComplete, this)
    Signals.continueBtnClick.add(this.onContinueBtnClick, this)
    document.addEventListener("UIIsLoaded", this.onUIIsLoaded.bind(this))
    this.useEffect()

    this.backendManager = new BackendManager()
    this.model = new Model ()
  }

  onLoadAssets() {
    this.appLoader = new ApplicationLoader()
    this.appLoader.loadPreloadingAssets()
  }

  onPreloaderAssetsLoadingComplete = () => {
    const styles = PIXI.Loader.shared.resources['PixiTextStyles'].data
    const strings = PIXI.Loader.shared.resources['LocalizedStrings'].data
    Facade.textFactory = new TextFactory(styles, strings, Config.locale)

    const locale = Facade.urlParams.language
    Facade.locale = locale
    Facade.textFactory.changeLocaleAndRefresh(Facade.locale)

    if (!PIXI.utils.isWebGLSupported()) {
      console.log('isWebGLSupported = FALSE')
      new UIManager()
      Signals.hardwareAcceleration.dispatch();
      //  setTimeout(() => this.webGlIsNotSupported(), 2000)
    } else {
      this.stage = new Stage()
      this.preloaderContainer = new PreloaderContainer()
      this.stage.addChild(this.preloaderContainer)

      // `if(Platform.isIOs()) {
      //   this.fullscreenController = new FullscreenIOSController()
      // }`

      if(!Platform.isMobile()) {
        document.body.style.overflow = "hidden"
      }

      this.appLoader.loadMainGameAssets()
    }
  }

  onMainGameAssetsLoadingComplete = () => {
    this.dataField = new DataField ()
    this.gameManager = new GameManager (this.dataField)
    this.mainContainer = new MainContainer(this.dataField)

    this.isGameLoaded = true

    if(this.isUIIsLoaded && !this.isUIInited) {
      this.isUIInited = true
      Signals.initUI.dispatch()
    }
    this.preloaderContainer.destroy()
    this.stage.removeChild (this.preloaderContainer)
    this.preloaderContainer = null
    this.splashScreenContainer = new SplashScreenContainer()
    this.stage.addChild(this.splashScreenContainer)
  }

  onUIIsLoaded = () => {
    this.isUIIsLoaded = true

    if(this.isGameLoaded && !this.isUIInited) {
      this.isUIInited = true
      Signals.initUI.dispatch()
    }
  }

  onContinueBtnClick = () => {
    this.splashScreenContainer.destroy()
    this.stage.removeChild (this.splashScreenContainer)
    this.splashScreenContainer = null

    this.stage.addChild(this.mainContainer)
    document.dispatchEvent(new CustomEvent("show", {}))
  }

  onURLParametersParsed(data) {

  }

  useEffect() {
    const handleTabClosing = () => {
      Signals.gameMessage.dispatch('terminate')
    }
    window.addEventListener('beforeunload', handleTabClosing)
    window.addEventListener('close', handleTabClosing)
  }

}
